import { call } from './utils';

//****PAYMENTS ACCOUNT OF INTEREST CRUD

//payments account creation
export const cancelPaymentAccount = async (data, accessToken) =>
  await call({
    url: '/api/payment_accounts/cancel/account',
    data: { data },
    token: accessToken,
    method:'POST'
  });

//payments account creation
export const getPaymentAccount = async (data, accessToken) =>
  await call({
    url: '/api/payment_accounts/get/account',
    data: { data },
    token: accessToken,
    method:'POST'
  });

//payments account creation
export const createPaymentAccount = async (data, accessToken) =>
  await call({
    url: '/api/payment_accounts/create/account',
    data: { data },
    token: accessToken,
    method:'POST'
  });